<template>
  <i class="mdi" :class="iconClass"></i>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconClass() {
      return `mdi-${this.name}`;
    },
  },
};
</script>
